export default {
    revert_rma_title: "Revertir RMA",
    revert_rma_input: "IMEI o serie",
    revert_rma_imei: "IMEI",
    revert_rma_serial: "Serie",
    revert_rma_model: "Modelo",
    revert_rma_change: "Revertir",
    revert_rma_no_devices_added: "No se han añadido dispositivos",
    revert_rma_device_is_already_added: "El dispositivo ya está añadido",
    revert_rma_device_has_not_been_found: "No se ha encontrado el dispositivo",
    revert_rma_this_feature_is_not_available: "Esta función no está disponible",
    revert_rma_single_success_message: "Al dipositivo se le removio la marca RMA",
    revert_rma_multiple_success_message: "A lLos dispositivos se les removio la RMA",
    revert_rma_error_message: "No se puede remover marcar RMA debido a un error",
    revert_rma_show_in_web: "Mostrar en la Web",
    revert_rma_number: "Número RMA",
    revert_rma_device_is_not_rma: "El dispositivo no está marcado como RMA",
    revert_rma_device_is_already_refirbished: "El dispositivo ya está remanufacturado",
    revert_rma_devices_is_not_rma: "Hay dipositivos que no estan marcados como RMA",
    revert_rma_devices_is_already_refirbished: "Hay dispositivos que ya fueron remanufacturados",
    revert_rma_min_message: "El número RMA debe tener al menos 5 digitos",
    revert_rma_revert_message_single: "la marca RMA será removida de este dispositivo y el estatus será cambiado a ACTIVO",
    revert_rma_revert_message: "la marca RMA será removida de estos dispositivos y el estatus será cambiado a ACTIVO",
}